import { useEffect } from 'react';

interface ShortcutHandlers {
  onSearchFocus?: () => void;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  onToggleTheme?: () => void;
  onEscape?: () => void;
  onGoHome?: () => void;
}

export function useKeyboardShortcuts(handlers: ShortcutHandlers) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      const isTyping = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;

      if (e.key === 'Escape') {
        handlers.onEscape?.();
        return;
      }

      if (isTyping) return;

      if (e.key === '/' || (e.key === 'k' && (e.ctrlKey || e.metaKey))) {
        e.preventDefault();
        handlers.onSearchFocus?.();
      } else if (e.key === '+' || e.key === '=') {
        e.preventDefault();
        handlers.onZoomIn?.();
      } else if (e.key === '-' || e.key === '_') {
        e.preventDefault();
        handlers.onZoomOut?.();
      } else if (e.key === 't' && !e.ctrlKey && !e.metaKey) {
        e.preventDefault();
        handlers.onToggleTheme?.();
      } else if (e.key === 'h' && !e.ctrlKey && !e.metaKey) {
        e.preventDefault();
        handlers.onGoHome?.();
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [handlers]);
}
